export type IBillsItem = {
    id: string;
    count: number;
    index: number;
    month: string;
    active: boolean;
    amount: number;
    issueDate: string;
    monthItem: string;
    payment: boolean;
    monthSort: string;
    legalEntity?: string;
    debt: number;
};

export type IBill = {
    id: string;
    amount: number;
    issueDate: Date;
    legalEntity: string;
    debt: number | null;
};

export type BillsMonthType = {
    active: boolean;
    amount: number;
    count: number;
    debt: number | null;
    month: string;
    monthItem: string;
    monthSort: string;
    payment: boolean;
    year: string;
};

export type BillFileType = {
    id: string;
    file: File;
};

export type IBillDetail = {
    id: string;
};

// GCO
export enum EMessageTypeGCO {
    TRACKING = 'tracking',
    FLOW = 'flow',
}

export enum EResponsePreventInteractionGCO {
    INVALID_REQUEST = 'invalid_request',
    UNAUTHORIZED_CLIENT = 'unauthorized_client',
    USER_CANCELLED = 'user_cancelled',
    SERVER_ERROR = 'server_error',
    TEMPORARILY_UNAVAILABLE = 'temporarily_unavailable',
}

export enum EResponseFinishInteractionGCO {
    SUCCESS = 'success',
    ERROR = 'error',
}

export type IEventGCO = {
    type: string;
    event: string;
};

export interface ITrackingScreenGCO {
    screen: string;
    type: string;
    id: string;
    data: { [key: string]: string };
}

export type ITrackingGCO = {
    messageType: EMessageTypeGCO;
    message: ITrackingScreenGCO;
};

export type IEventFinishInteractionGCO = {
    callbackUrl: string;
    nonce?: string;
    result: EResponseFinishInteractionGCO;
};

export type IEventPreventInteractionGCO = {
    callbackUrl: string;
    nonce?: string;
    error_description: string;
    error: EResponsePreventInteractionGCO;
};

export type IEventTrackingGCO = {
    messageType: EMessageTypeGCO;
    message: ITrackingScreenGCO;
};

export type IEventSourceGCO = {
    source: string;
    payload: IEventGCO;
};

export type UEventsGCO = IEventTrackingGCO & IEventSourceGCO;
export type UEventsResponseGCO = IEventFinishInteractionGCO & IEventPreventInteractionGCO;
